import { ReactNode } from "react";
import { Params, useParams } from "react-router-dom";
import { LinkOpeningProblemAlert } from "./LinkOpeningProblemAlert";

interface Props {
  nodeExpectingPlaylistIdentifier: (playlistIdentifier: string) => ReactNode;
}

export const playlistIdentifierParamKey = "playlistIdentifier";

export function ParamValidatorPlaylistIdentifier(props: Props) {
  const params: Readonly<Params<string>> = useParams();

  const optionalPlaylistIdentifier = params[playlistIdentifierParamKey];

  if (optionalPlaylistIdentifier === undefined)
    return (
      <LinkOpeningProblemAlert>
        Der Identifier der Playlist fehlt.
      </LinkOpeningProblemAlert>
    );

  return props.nodeExpectingPlaylistIdentifier(optionalPlaylistIdentifier);
}
